module.exports = __webpack_public_path__ + "img/tower-red.1486af41.png";